export const GET_AGENT_INPUTS_HISTORY = 'GET_AGENT_INPUTS_HISTORY';
